import styled, { css } from 'styled-components'

import type { TradeType } from '@root/entities/trade-type'
import type { ClassNameProps } from '@root/shared/lib/react'

type Props = {
  swapDirection: TradeType.SwapDirection
  buyLabel: string
  sellLabel: string
  onChange?: (tab: TradeType.SwapDirection) => void
  orderType?: TradeType.OrderType
} & ClassNameProps

export const TradeSettingsType: React.FC<Props> = ({
  swapDirection,
  orderType,
  onChange,
  buyLabel,
  sellLabel,
  className,
}) => (
  <Root
    className={className}
    data-order-type={orderType}
    aria-expanded={orderType === 'limit'}
  >
    <Item
      onClick={() => onChange?.('buy')}
      $type="buy"
      $active={swapDirection === 'buy'}
    >
      {buyLabel}
    </Item>
    <Item
      onClick={() => onChange?.('sell')}
      $type="sell"
      $active={swapDirection === 'sell'}
    >
      {sellLabel}
    </Item>
  </Root>
)

const Root = styled.div`
  background: var(--background-3);
  gap: 8px;

  display: grid;
  grid-template-columns: auto auto;
  padding: 3px;
  overflow: hidden;

  border-radius: 20px;
  height: 36px;
`

const Item = styled.div<{ $active: boolean; $type: TradeType.SwapDirection }>`
  color: ${({ $active }) => ($active ? 'var(--text-12)' : 'var(--text-11)')};
  cursor: ${({ $active }) => ($active ? 'default' : 'pointer')};

  height: 30px;
  padding-inline: 10px;
  border-radius: 17px;

  display: grid;
  align-items: center;
  justify-items: center;

  font-size: 13px;
  font-weight: 700;
  line-height: 16px;

  text-transform: uppercase;
  transition: all 0.15s ease-in;

  ${({ $active, $type }) => {
    if ($active) {
      if ($type === 'buy') {
        return css`
          background: var(--upAccent-9);
          box-shadow: 0px 0px 40px 0px rgba(var(--upAccent-9-rgb), 0.5);
        `
      }
      return css`
        background: var(--downAccent-9);
        box-shadow: 0px 0px 40px 0px rgba(var(--downAccent-9-rgb), 0.5);
      `
    }

    return css`
      background: var(--background-6);
    `
  }}
  [data-order-type='limit'] & {
    transition: none;
    html[lang='ru'] & {
      font-size: 9px;
      padding-inline: 2px;
    }
  }
`
